import './tabletop/style';
import FormStructure from './tabletop/form_structure';

export default FormStructure;